import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { UFS, Municipio, MUNICIPIOS } from '../../shared/localizacao/municipios';
import { S3SpcPublicService } from '../../services/s3-spc-public.service';
 
@Component({
  selector: 'app-spc-municipio',
  templateUrl: './spc-municipio.component.html',
  styleUrls: ['./spc-municipio.component.css']
})
export class SpcMunicipioComponent implements OnInit {

  ufSelecionada: string | null = null;
  dataSelecionada: string | null = null;
  datas: string[] = [];

  displayedColumns: string[] = [
    'nome',
    'semSeca',
    's0s4',
    's1s4',
    's2s4',
    's3s4',
    's4'
  ];
 
  dataSource = new MatTableDataSource<Municipio>();
  ufs = UFS;
  // países (no momento apenas Brasil)
  paises = [{ nome: 'Brasil', sigla: 'BR', alias: 'brasil' }];
  loading = false;
  spcS0Loading = false;
  spcS1Loading = false;
  spcS2Loading = false;
  spcS3Loading = false;
  spcS4Loading = false;
  spcS0Error = false;
  spcS1Error = false;
  spcS2Error = false;
  spcS3Error = false;
  spcS4Error = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private s3SpcPublicService: S3SpcPublicService
  ) {}

  navegarParaUf(uf: string) {
    this.router.navigate(['/spc/municipio', uf], {
      queryParams: this.currentQueryParams
    });
  }

  onDataChange(): void {
    const shouldLoad = !!this.ufSelecionada;
    this.spcS0Loading = shouldLoad;
    this.spcS1Loading = shouldLoad;
    this.spcS2Loading = shouldLoad;
    this.spcS3Loading = shouldLoad;
    this.spcS4Loading = shouldLoad;
    this.spcS0Error = false;
    this.spcS1Error = false;
    this.spcS2Error = false;
    this.spcS3Error = false;
    this.spcS4Error = false;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: this.currentQueryParams,
      queryParamsHandling: 'merge'
    });
  }

  get currentQueryParams(): { data?: string } {
    return this.dataSelecionada ? { data: this.dataSelecionada } : {};
  }

  private applySelectedData(preferredData: string | null): void {
    if (preferredData && this.datas.includes(preferredData)) {
      this.dataSelecionada = preferredData;
      return;
    }

    this.dataSelecionada = this.datas[0] ?? null;
  }

  onSpcS0Load(): void {
    this.spcS0Loading = false;
    this.spcS0Error = false;
  }

  onSpcS0Error(): void {
    this.spcS0Loading = false;
    this.spcS0Error = true;
  }

  onSpcS1Load(): void {
    this.spcS1Loading = false;
    this.spcS1Error = false;
  }

  onSpcS1Error(): void {
    this.spcS1Loading = false;
    this.spcS1Error = true;
  }

  onSpcS2Load(): void {
    this.spcS2Loading = false;
    this.spcS2Error = false;
  }

  onSpcS2Error(): void {
    this.spcS2Loading = false;
    this.spcS2Error = true;
  }

  onSpcS3Load(): void {
    this.spcS3Loading = false;
    this.spcS3Error = false;
  }

  onSpcS3Error(): void {
    this.spcS3Loading = false;
    this.spcS3Error = true;
  }

  onSpcS4Load(): void {
    this.spcS4Loading = false;
    this.spcS4Error = false;
  }

  onSpcS4Error(): void {
    this.spcS4Loading = false;
    this.spcS4Error = true;
  }

  toGpkgUrl(url: string | null): string | null {
    if (!url) {
      return null;
    }
    return url.replace(/\.png(?=($|\?))/i, '.gpkg');
  }

  extractFileName(url: string | null, fallback: string): string {
    if (!url) {
      return fallback;
    }
    const semQuery = url.split('?')[0];
    return semQuery.substring(semQuery.lastIndexOf('/') + 1) || fallback;
  }

  downloadFile(url: string | null | undefined, fileName: string): void {
    if (!url) {
      return;
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  private buildImagemSpcUrl(nivel: 's0' | 's1' | 's2' | 's3' | 's4'): string | null {
    if (!this.ufSelecionada || !this.dataSelecionada) {
      return null;
    }

    // localizar UF ou País pelo código
    const uf = UFS.find(u => u.sigla === this.ufSelecionada) || this.paises.find(p => p.sigla === this.ufSelecionada);
    if (!uf) {
      return null;
    }

    /**
     * dataSelecionada no formato MM/YYYY
     * Ex: 10/2025 -> 202510
     */
    const [mes, ano] = this.dataSelecionada.split('/');
    if (!mes || !ano) {
      return null;
    }

    const anoMes = `${ano}${mes.padStart(2, '0')}`;

    return `https://ana-monitor-secas-files.s3.sa-east-1.amazonaws.com/uploads/produtos/srm_persist/${anoMes}/persist_cat/persistencia_por_categoria_${uf.alias}_${anoMes}_${nivel}.png`;
  }

  get imagemSpcS0Url(): string | null {
    return this.buildImagemSpcUrl('s0');
  }

  get imagemSpcS1Url(): string | null {
    return this.buildImagemSpcUrl('s1');
  }

  get imagemSpcS2Url(): string | null {
    return this.buildImagemSpcUrl('s2');
  }

  get imagemSpcS3Url(): string | null {
    return this.buildImagemSpcUrl('s3');
  }

  get imagemSpcS4Url(): string | null {
    return this.buildImagemSpcUrl('s4');
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;

    try {
      const months = await this.s3SpcPublicService.listAvailableMonths();
      const datasS3 = months
        .filter(m => /^\d{6}$/.test(m))
        .map(m => `${m.slice(4)}/${m.slice(0, 4)}`);
      if (datasS3.length > 0) {
        this.datas = datasS3;
      }
    } catch (err) {
      console.error('Não foi possível listar meses S3 (SPC):', err);
    } finally {
      this.loading = false;
    }

    this.route.paramMap.subscribe(params => {
      const uf = params.get('uf');
      this.ufSelecionada = uf ? uf.toUpperCase() : null;
      this.onDataChange();

      if (!this.ufSelecionada) {
        this.dataSource.data = [];
        return;
      }

      const items = MUNICIPIOS.filter(m => m.uf === this.ufSelecionada);
      console.log(`UF: ${this.ufSelecionada}, Itens encontrados:`, items);
      this.dataSource.data = items ?? [];
    });

    this.route.queryParamMap.subscribe(queryParams => {
      this.applySelectedData(queryParams.get('data'));
      this.onDataChange();
    });

    if (!this.dataSelecionada && this.datas.length > 0) {
      this.applySelectedData(this.route.snapshot.queryParamMap.get('data'));
    }
  }
}
 
